import { useCallback, useEffect } from 'react'
import { Helmet } from 'react-helmet-async'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'
import api from '../../../api'
import Responsive from '../../../assets/config/Responsive'
import Colors from '../../../assets/styles/Colors'
import Loader from '../../../components/Loader'
import BackgroundIcon from '../../../components/v2/BackgroundIcon'
import HorizontalCard from '../../../components/v2/HorizontalCard'
import InfoMessage from '../../../components/v2/InfoMessage'
import RemainingCompanies from '../../../components/v2/RemainingCompanies'
import ScreenHeader from '../../../components/v2/ScreenHeader'
import Title from '../../../components/v2/Title'
import NavigationButton from '../../../components/v2/buttons/NavigationButton'
import RadioButton from '../../../components/v2/buttons/RadioButton'
import TplProgressbar from '../../../components/v2/progrees-bars/TplProgressbar'
import { currencySymbol } from '../../../domain/types'
import { useAppDispatch, useAppSelector } from '../../../store'
import { AppState } from '../../../store/appSlice'
import { TplState, setCurrencies, setCurrency, setHeaderPassedCount, setLimit } from '../../../store/tplSlice'
import React from 'react'

const WhichCurrency = () => {
  //
  const { lang } = useAppSelector((root: { app: AppState }) => root.app)
  //
  //
  const { data: tplCurrencies, isLoading: isTplCurrenciesLoading } = api.useGetTplCurrenciesQuery(undefined)
  //
  //
  const { t } = useTranslation()
  //
  //
  const navigate = useNavigate()
  //
  //
  const dispatch = useAppDispatch()
  //
  //
  const pageTitle = tplCurrencies?.translations[lang]?.title
  const stepName = tplCurrencies?.translations[lang]?.stepName

  //
  const { filter, screenHeader } = useAppSelector((data: { tpl: TplState }) => data.tpl)
  //
  //
  const queryCurrencyStr = `ProductCategorySlug=${filter.productCategory}&StartDate=${filter.dates?.start}&EndDate=${
    filter.dates?.end
  }&Currency=${filter.currency?.toUpperCase()}`
  //
  const queryLimityStr = `ProductCategorySlug=${filter.productCategory}&StartDate=${filter.dates?.start}&EndDate=${
    filter.dates?.end
  }&Currency=${filter.currency?.toUpperCase()}&Limit=${filter.limit}`
  //
  //
  const { data: tplLeftCompanies } = api.useGetTplLeftCompaniesQuery(
    {
      stepName: !filter.limit ? 'two' : 'three',
      query: !filter.limit ? queryCurrencyStr : queryLimityStr,
    },
    { skip: !filter.currency ? true : false, refetchOnMountOrArgChange: true },
  )
  //

  //
  const watchAndSetInfo = useCallback(() => {
    //
    const currencies = tplCurrencies?.listItems?.map((x) => x.type?.toUpperCase())
    //
    // set currencies
    if (
      // set income currencies in redux store for best offer
      tplCurrencies &&
      tplCurrencies.listItems &&
      tplCurrencies.listItems.length >= 1 &&
      currencies &&
      currencies.length >= 1
    ) {
      dispatch(setCurrencies(currencies))
    }
    //
  }, [tplCurrencies, dispatch])
  //
  //
  // set currencies in store
  useEffect(() => {
    watchAndSetInfo()
    //
    return () => {}
  }, [watchAndSetInfo])
  //
  //
  // auto navigate first page
  useEffect(() => {
    if (!filter.dates?.start) {
      navigate('/tpl-choose-days')
    }
    //
    return () => {}
  }, [filter.dates?.start, navigate])
  //
  //
  const mainLoading = isTplCurrenciesLoading
  //
  return mainLoading ? (
    <Loader />
  ) : (
    <Wrapper>
      <Helmet>
        <title>{pageTitle}</title>
        <meta name="description" content={pageTitle} />
        <link rel="canonical" href={window.location.href} />
      </Helmet>

      <ScreenHeader totalCount={screenHeader.totalCount} passedCount={screenHeader.passedCount} />

      <Content>
        <Title text={pageTitle} />

        <TplProgressbar stepName={stepName} />

        <Block>
          <Cards>
            {tplCurrencies &&
              tplCurrencies?.listItems?.map((item, index) => {
                return (
                  <HorizontalCard
                    className="horizontal-card"
                    key={index}
                    disabled={false}
                    title={item?.title}
                    imgUrl={item?.image}
                    selected={item.type?.toUpperCase() === filter.currency ? true : false}
                    onClick={() => {
                      if (item.type) {
                        dispatch(setCurrency(item.type?.toUpperCase()))
                        //
                        if (filter.currency !== item.type) {
                          dispatch(setLimit(null))
                        }
                      }
                    }}
                  >
                    {item.type?.toUpperCase() === filter.currency ? (
                      <LimitDiv>
                        <hr />
                        <LimitTitle>{t('chooseLimit')}</LimitTitle>
                        <LimitDescription>{t('maximumLimit')}</LimitDescription>

                        <CheckboxBlock>
                          <RadioButton
                            size="small"
                            defaultOption={filter.limit}
                            onChange={(value) => {
                              dispatch(setLimit(Number(value)))
                            }}
                            options={
                              tplLeftCompanies
                                ? [
                                    ...[...tplLeftCompanies.limits] // new array
                                      .sort((a, b) => a - b) // sort
                                      .map((value) => ({
                                        value: value,
                                        label:
                                          value?.toString()?.replace(/\B(?=(\d{3})+(?!\d))/g, ' ') +
                                          ` ${currencySymbol(filter.currency)}`,
                                      })),
                                  ]
                                : []
                            }
                          />
                        </CheckboxBlock>
                        {tplLeftCompanies && tplLeftCompanies.limits.length <= 0 && (
                          <InfoMessage
                            background="gray"
                            variant="info"
                            title={`${t('limit')}`}
                            text={`${t('notFoundLimits')}`}
                          />
                        )}
                      </LimitDiv>
                    ) : null}
                  </HorizontalCard>
                )
              })}
          </Cards>

          <RemainingCompanies
            style={{
              opacity: tplLeftCompanies ? '1' : '0',
            }}
            text={`${t('offerAvailable')}: ${tplLeftCompanies?.companiesCount} `}
          />
        </Block>

        <Buttons>
          <NavigationButton
            text={`${t('back')}`}
            buttonType="prev"
            onClick={() => [dispatch(setHeaderPassedCount(screenHeader.passedCount - 1)), navigate('/tpl-choose-days')]}
          />
          <NavigationButton
            text={`${t('next')}`}
            buttonType="next"
            disabled={
              filter.currencies &&
              filter.currencies.length >= 1 &&
              filter.productCategory &&
              filter.dates &&
              filter.dates?.start &&
              filter.currency &&
              filter.limit &&
              tplLeftCompanies &&
              tplLeftCompanies.companiesCount >= 1
                ? false
                : true
            }
            onClick={() => [dispatch(setHeaderPassedCount(4)), navigate('/tpl-extra-services')]}
          />
        </Buttons>
      </Content>

      <BackgroundIcon />
    </Wrapper>
  )
}
//
const Block = styled.div`
  max-width: 464px;
  margin-inline: auto;
`
const CheckboxBlock = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: repeat(2, 1fr);
  grid-column-gap: 0px;
  grid-row-gap: 10px;
`
const LimitTitle = styled.p`
  font-size: 18px;
  color: ${Colors.primaryBlack};
  margin-bottom: 4px;
`
const LimitDescription = styled.p`
  font-size: 14px;
  color: ${Colors.nevadaGrey};
  margin-bottom: 18px;
`
const LimitDiv = styled.div``

const Buttons = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-inline: auto;
  width: 100%;
  margin-top: 48px;
  max-width: 368px;

  button {
    width: 100%;
    padding-inline: 0px;
    &:first-child {
      margin-right: 20px;
    }
  }

  ${Responsive.mobile} {
    max-width: 296px;
    margin-top: 40px;
    button {
      &:first-child {
        margin-right: 15px;
      }
    }
  }
`
const Cards = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 32px;
  min-width: 464px;

  .horizontal-card-content {
    align-items: center;
  }

  .horizontal-card {
    margin-bottom: 24px;
    &:last-child {
      margin-bottom: 0px;
    }
  }

  ${Responsive.mobile} {
    margin-top: 24px;

    min-width: unset;

    .horizontal-card {
      margin-bottom: 20px;
      &:last-child {
        margin-bottom: 0px;
      }
    }
  }
`
const Content = styled.div`
  margin-top: 58px;
  z-index: 2;
  padding-inline: 20px;
  width: 100%;

  ${Responsive.mobile} {
    margin-top: 26px;
  }
`
const Wrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  background-color: ${Colors.backgroundGrey};
  padding-bottom: 20px;
  min-height: 100vh;
`
export default WhichCurrency
